import { FlexColumn } from '@editor/components/utilities/layouts';
import type { SubscriptionFullPlanObject } from '@repo/subscription/api';
import CalendarIcon from '@repo/ui/components/Icon/CalendarIcon';
import TeamIcon from '@repo/ui/components/Icon/TeamIcon';
import { H4 } from '@repo/ui/components/Typography';
import { themeStyle, useNewThemeActive } from '@repo/ui/theming';

import { formatMonetaryValue } from '../../../../utils/billing';
import { capitalizeFirstLetter } from '../../../../utils/string';
import { getIntervalName } from '../../utils';

import { PlanInfoDescription, PlanInfoRow, PlanInfoWrapper } from './styles';

const iconTheme = {
  color: themeStyle.varBrandMain,
  disabledColor: themeStyle.varInkMedium,
};

const newIconTheme = {
  color: themeStyle.varBlueMedium,
  disabledColor: themeStyle.varInkMedium,
};

const PlanCard: React.FC<{
  plan: SubscriptionFullPlanObject;
  disabled?: boolean;
}> = ({ plan, disabled }) => {
  const { quantity, amount, interval } = plan;

  const isNewThemeActive = useNewThemeActive();

  return (
    <FlexColumn gap="8px">
      <PlanInfoWrapper>
        <PlanInfoRow>
          <TeamIcon
            disabled={disabled}
            theme={isNewThemeActive ? newIconTheme : iconTheme}
          />
          <PlanInfoDescription>{quantity} members</PlanInfoDescription>
        </PlanInfoRow>
        <PlanInfoRow>
          <CalendarIcon
            disabled={disabled}
            theme={isNewThemeActive ? newIconTheme : iconTheme}
          />
          <PlanInfoDescription>
            {capitalizeFirstLetter(getIntervalName(interval))}ly payment
          </PlanInfoDescription>
        </PlanInfoRow>
      </PlanInfoWrapper>
      <H4 as="div" color={themeStyle.varInkMedium} margin="16px auto 0 auto">
        {formatMonetaryValue({
          amount: amount * quantity,
          // TODO: remove ts-ignore once BE is merged https://app.clickup.com/t/86c2ztc52
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          currency: plan.currency,
        })}{' '}
        per {getIntervalName(interval)}
      </H4>
    </FlexColumn>
  );
};

export default PlanCard;
